import api from './api';

const handleError = (error) => {
  console.error('API Error:', error);
  
  // If the error has a response, handle it appropriately
  if (error.response) {
    console.error('Error data:', error.response.data);
    console.error('Error status:', error.response.status);
    
    // For 404 errors, return null instead of throwing
    if (error.response.status === 404) {
      return null;
    }
    
    throw new Error(
      error.response.data.error || 
      error.response.data.message || 
      error.response.data.detail || 
      'An error occurred'
    );
  }
  
  // Network errors
  if (error.request) {
    throw new Error('Unable to connect to the server. Please check your internet connection.');
  }
  
  // Configuration errors
  throw new Error('An error occurred while setting up the request');
};

const dcqService = {
  getSingleDCQ: async (dcqId) => {
    if (!dcqId) {
      console.error('No DCQ ID provided');
      return null;
    }

    try {
      const response = await api.get(`/api/dcqs/${dcqId}/`);
      return response.data;
    } catch (error) {
      return handleError(error);
    }
  },

  getCommentsForDCQ: async (dcqId) => {
    if (!dcqId) {
      console.error('No DCQ ID provided');
      return [];
    }

    try {
      const response = await api.get(`/api/dcqs/${dcqId}/comments/`);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching comments:', error);
      return [];  // Return empty array instead of throwing
    }
  },

  getAllDCQs: async () => {
    try {
      const response = await api.get('/api/dcqs/');
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  getDCQsForStudy: async (studyID) => {
    try {
      const response = await api.get(`/api/dcqs/bystudy/${studyID}/`);
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  getDCQsForSite: async (studyID, siteID) => {
    try {
      const response = await api.get(`/api/studies/${studyID}/sites/${siteID}/dcqs/`);
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  getDCQsForParticipant: async (participantID) => {
    try {
      const response = await api.get(`/api/dcqs/byparticipant/${participantID}/`);
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },


  getUsernamesForDCQ: async (dcqId) => {
    try {
      const response = await api.get(`/api/dcqs/${dcqId}/usernames/`);
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  addComment: async (dcqId, comment) => {
    try {
      const response = await api.post(`/api/dcqs/${dcqId}/comments/create/`, {
        comment: comment
      });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  updateDCQ: async (dcqId, payload) => {
    try {
      const response = await api.put(`/api/dcqs/${dcqId}/update/`, payload);
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },

  createDCQ: async (payload) => {
    try {
      const response = await api.post('/api/dcqs/create/', payload);
      return response.data;
    } catch (error) {
      handleError(error);
    }
  },
};

export default dcqService;